<div class="view-page-container">
  <div class="view-toolbar">
    <button type="button" pButton (click)="backClicked.emit()"><msi-icon name="ic_back" /></button>
    <div class="view-toolbar-right">
      <button type="button" pButton (click)="deleteClicked.emit()" [disabled]="!CanDelete">
        <msi-icon name="ic_trash" />{{ 'Buttons.delete' | transloco }}
      </button>
      <button type="button" pButton (click)="editButtonClicked()" [disabled]="!CanEdit">
        <msi-icon name="ic_edit" />{{ 'Buttons.edit' | transloco }}
      </button>
    </div>
  </div>
  <ng-container *transloco="let t; prefix: 'PremiseHazardType'">
    <div class="item-view-container">
      @if (PremiseHazardType) {
      <ng-container *ngTemplateOutlet="headerInformation"></ng-container>
      <ng-container *ngTemplateOutlet="proximityInformation"></ng-container>
      <ng-container *ngTemplateOutlet="descriptionInformation"></ng-container>
      <ng-container *ngTemplateOutlet="expandedInformation"></ng-container>
      <ng-container *ngTemplateOutlet="systemInformation"></ng-container>
      } @else {
      {{ t('View.text.noRecords') }}
      }
    </div>



    <ng-template #headerInformation>
      <div class="type-information-header">
        <label class="msi-label">{{ t('label.code') }}</label>
        <div class="msi-margin-left-s">{{ PremiseHazardType!.code }}</div>
      </div>
      @if (isShared) {
      <div>
        <div class="msi-margin-s">
          <msi-callout [type]="infoCalloutType" [closable]="false">
            <div calloutContent>
              {{ t('View.text.sharedData') }}
            </div>
          </msi-callout>
        </div>
      </div>
      }
    </ng-template>

    <ng-template #proximityInformation>
      <div>
        <label class="msi-label">{{ t('View.section.proximities') }}<msi-icon name="ic_help"
            [pTooltip]="t('tooltip.roundingWarning')" /></label>
        <div class="view-wrapper">
          <div class="information-column">
            <label class="msi-label">{{ t('label.directHit') }}</label>
            <div class="msi-margin-left-s">
              {{ directHitDistanceDisplay | number: NUMBER_FORMATS[selectedUnits] }} {{ currentUnitsText }}
            </div>
          </div>

          <div class="information-column-margin">
            <label class="msi-label">{{ t('label.innerProximity') }}</label>
            <div class="msi-margin-left-s">
              {{ innerProximityDistanceDisplay | number: NUMBER_FORMATS[selectedUnits] }} {{ currentUnitsText }}
            </div>
          </div>

          <div class="information-column-margin">
            <label class="msi-label">{{ t('label.outerProximity') }}</label>
            <div class="msi-margin-left-s">
              {{ outerProximityDistanceDisplay | number: NUMBER_FORMATS[selectedUnits] }} {{ currentUnitsText }}
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #descriptionInformation>
      <div class="comments-wrapper">
        <label class="msi-label">{{ t('label.description') }}</label>
        <div class="comments-content">
          <p>
            {{ PremiseHazardType!.description | emptyText}}
          </p>
        </div>
      </div>
    </ng-template>

    <ng-template #expandedInformation>
      @if (showExpandedInformation) {
      <div class="type-information-header">
        <label class="msi-label">{{ t('View.section.alertInformation') }}</label>
        <div class="type-single-line-information">
          <div class="information-column">
            <label class="msi-label">{{ t('label.directHit') }}</label>
            <div class="msi-checkbox-group msi-margin-left-s">
              <div class="msi-checkbox-row"><p-checkbox [binary]="true" [ngModel]="PremiseHazardType!.directHitVisual"
                  [disabled]="true" /><label>{{ t('label.visual') }}</label></div>
              <div class="msi-checkbox-row"><p-checkbox [binary]="true" [ngModel]="PremiseHazardType!.directHitAudio"
                  [disabled]="true" /><label>{{ t('label.audible') }}</label></div>
            </div>
          </div>
          <div class="information-column-margin">
            <label class="msi-label">{{ t('label.innerProximity') }}</label>
            <div class="msi-checkbox-group msi-margin-left-s">
              <div class="msi-checkbox-row"><p-checkbox [binary]="true"
                  [ngModel]="PremiseHazardType!.innerProximityVisual" [disabled]="true" /><label>{{ t('label.visual')
                  }}</label></div>
              <div class="msi-checkbox-row"><p-checkbox [binary]="true"
                  [ngModel]="PremiseHazardType!.innerProximityAudio" [disabled]="true" /><label>{{ t('label.audible')
                  }}</label></div>
            </div>
          </div>
          <div class="information-column-margin">
            <label class="msi-label">{{ t('label.outerProximity') }}</label>
            <div class="msi-checkbox-group msi-margin-left-s">
              <div class="msi-checkbox-row"><p-checkbox [binary]="true"
                  [ngModel]="PremiseHazardType!.outerProximityVisual" [disabled]="true" /><label>{{ t('label.visual')
                  }}</label></div>
              <div class="msi-checkbox-row"><p-checkbox [binary]="true"
                  [ngModel]="PremiseHazardType!.outerProximityAudio" [disabled]="true" /><label>{{ t('label.audible')
                  }}</label></div>
            </div>
          </div>
        </div>
      </div>
      }
    </ng-template>

    <ng-template #systemInformation>
      <div class="type-information-header">
        <label class="msi-label">{{ t('View.section.systemInfo') }}</label>

        <div class="type-single-line-information">
          <div class="information-column">
            <label class="msi-label">{{ t('label.displayOrder') }}</label>
            <div class="msi-margin-left-s">
              {{ PremiseHazardType!.displayOrder ?? t('label.noValue') }}
            </div>
          </div>

          <div class="information-column-margin">
            <label class="msi-label">{{ t('label.tearAndRunOrder') }}</label>
            <div class="msi-margin-left-s">
              {{ PremiseHazardType!.tearAndRunOrder ?? t('label.noValue') }}
            </div>
          </div>
        </div>
        <div class="type-single-line-information">
          <div class="information-column">
            <label class="msi-label">{{ t('label.createdOn') }}</label>
            <div class="msi-margin-left-s">
              {{ PremiseHazardType!.insertedTimestamp | date:dateFormat }}
            </div>
          </div>

          <div class="information-column-margin">
            @if (PremiseHazardType?.updatedTimestamp) {
            <label class="msi-label">{{ t('label.updatedOn') }}</label>
            <div class="msi-margin-left-s">
              {{ PremiseHazardType!.updatedTimestamp | date:dateFormat }}
            </div>
            }

          </div>
        </div>
      </div>
    </ng-template>

  </ng-container>
</div>